import Domain from "./domain";
export default {
  methods: {
    addPolicy: async function(policy) {
      try {
        /*	
          {
            "policy":"demote test",
            "policy_link":"dad",
            "active_types":[1,2]
          }
        }*/
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "admin/policy",
          policy,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    updatePolicy: async function(policy) {
      try {
        /*	
          "_id": "5d53a9ec692622315c5dba6d",
          "policy_link":"http://edupass.com.au/privacy-policy",
          "active_types": [ 3, 4 ]
        }*/
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/policies/link",
          policy,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deletePolicy: async function(policyId) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/company/policies/" + policyId,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getPolicies: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/company/policies/details/?user_type",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    geContractorById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/company/contractor/details/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postContractor: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/contractor",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putContractor: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/contractor",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteContractor: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/company/contractor/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postContractorImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/contractor/avatar",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
